import styled from 'styled-components'
import { mq } from '../../styles/vars/media-queries.style'
import { Label } from '../../styles/vars/textStyles.style'

export const AmenitiesMain = styled.div`
  ${Label} {
    font-weight: 400;
    opacity: 0.5;
    text-transform: none;
  }
`

export const AmenitiesCTA = styled.div`
  margin-bottom: 3rem;

  ${mq.tabletL} {
    margin-bottom: 0;
  }
`

export const AmenitiesList = styled.div`
  ul {
    overflow: hidden;
    list-style: none;
  }
`
